export default {"src":"/_next/static/media/ind.c57723be.svg","height":600,"width":900};